"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const NetworkAlert_1 = require("decentraland-ui/dist/components/NetworkAlert/NetworkAlert");
const Navbar_1 = require("decentraland-ui/dist/components/Navbar/Navbar");
const types_1 = require("decentraland-ui/dist/components/Notifications/types");
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const utils_1 = require("../../modules/analytics/utils");
const notifications_1 = require("../../modules/notifications");
const utils_2 = require("../../modules/translation/utils");
const utils_3 = require("../../lib/utils");
const ChainProvider_1 = __importDefault(require("../ChainProvider"));
const constants_1 = require("./constants");
const constants_2 = require("./constants");
const UnsupportedNetworkModal_1 = __importDefault(require("../UnsupportedNetworkModal"));
const BASE_URL = (0, utils_3.getBaseUrl)();
const Navbar = (_a) => {
    var { appChainId, isSwitchingNetwork, withNotifications, identity, docsUrl = 'https://docs.decentraland.org', enablePartialSupportAlert = true } = _a, props = __rest(_a, ["appChainId", "isSwitchingNetwork", "withNotifications", "identity", "docsUrl", "enablePartialSupportAlert"]);
    const [{ isLoading, notifications }, setUserNotifications] = (0, react_1.useState)({
        isLoading: false,
        notifications: []
    });
    const [notificationsState, setNotificationsState] = (0, react_1.useState)({
        activeTab: types_1.NotificationActiveTab.NEWEST,
        isOnboarding: (0, notifications_1.checkIsOnboarding)(),
        isOpen: false
    });
    const expectedChainName = (0, chain_id_1.getChainName)(appChainId);
    const analytics = (0, utils_1.getAnalytics)();
    const client = (0, react_1.useMemo)(() => {
        if (identity)
            return new notifications_1.NotificationsAPI({ identity });
        return null;
    }, [identity]);
    const handleSwitchNetwork = (0, react_1.useCallback)(() => {
        props.onSwitchNetwork(appChainId);
    }, []);
    const handleClickBalance = (0, react_1.useCallback)((e, network) => {
        e.preventDefault();
        analytics.track(constants_1.DROPDOWN_MENU_BALANCE_CLICK_EVENT, { network });
        setTimeout(() => {
            window.open(`${BASE_URL}/account`, '_blank', 'noopener');
        }, 300);
    }, [analytics]);
    const handleClickNavbarItem = (0, react_1.useCallback)((_e, options) => {
        analytics.track(constants_2.NAVBAR_CLICK_EVENT, options);
    }, [analytics]);
    const handleClickUserMenuItem = (0, react_1.useCallback)((_e, options) => {
        analytics.track(options.eventTrackingName, {
            url: options.url,
            trackingId: options.trackingId
        });
    }, [analytics]);
    const handleClickOpen = (0, react_1.useCallback)((_e, track_uuid) => {
        analytics.track(constants_1.DROPDOWN_MENU_DISPLAY_EVENT, { track_uuid });
    }, [analytics]);
    const handleClickSignIn = (0, react_1.useCallback)((_e) => {
        props.onSignIn();
    }, [analytics]);
    const handleClickSignOut = (0, react_1.useCallback)((_e, track_uuid) => {
        analytics.track(constants_1.DROPDOWN_MENU_SIGN_OUT_EVENT, { track_uuid });
        setTimeout(() => {
            props.onSignOut();
        }, 300);
    }, [analytics]);
    const handleOnBegin = () => {
        (0, notifications_1.setOnboardingDone)();
        setNotificationsState(prevState => (Object.assign(Object.assign({}, prevState), { isOnboarding: false })));
    };
    const handleNotificationsOpen = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentOpenState = notificationsState.isOpen;
        setNotificationsState(prevState => {
            return Object.assign(Object.assign({}, prevState), { isOpen: !prevState.isOpen });
        });
        if (!currentOpenState) {
            const unreadNotifications = notifications
                .filter(notification => !notification.read)
                .map(({ id }) => id);
            if (unreadNotifications.length) {
                yield (client === null || client === void 0 ? void 0 : client.markNotificationsAsRead(unreadNotifications));
            }
        }
        else {
            // update state when closes the modal
            const markNotificationAsReadInState = notifications.map(notification => {
                if (notification.read)
                    return notification;
                return Object.assign(Object.assign({}, notification), { read: true });
            });
            setUserNotifications({
                isLoading,
                notifications: markNotificationAsReadInState
            });
        }
    });
    const fetchNotificationsState = () => {
        setUserNotifications({ notifications: [], isLoading: true });
        client === null || client === void 0 ? void 0 : client.getNotifications().then(retrievedNotifications => {
            setUserNotifications({
                isLoading: false,
                notifications: retrievedNotifications
            });
        });
    };
    (0, react_1.useEffect)(() => {
        if (identity && withNotifications) {
            fetchNotificationsState();
            const interval = setInterval(() => {
                fetchNotificationsState();
            }, constants_2.NOTIFICATIONS_QUERY_INTERVAL);
            return () => {
                clearInterval(interval);
            };
        }
        else {
            return () => { };
        }
    }, [identity]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChainProvider_1.default, null, ({ chainId, isUnsupported, isPartiallySupported }) => (react_1.default.createElement(react_1.default.Fragment, null,
            isPartiallySupported && enablePartialSupportAlert ? (react_1.default.createElement(NetworkAlert_1.NetworkAlert, { i18n: {
                    title: (0, utils_2.t)('@dapps.network_alert.title'),
                    content: (0, utils_2.t)('@dapps.network_alert.content', {
                        link: (children) => (react_1.default.createElement("a", { href: `${docsUrl}/player/blockchain-integration/transactions-in-polygon/`, target: "_blank", rel: "noreferrer noopener" }, children))
                    }),
                    action: (0, utils_2.t)('@dapps.network_alert.action')
                }, onSwitchNetwork: handleSwitchNetwork })) : null,
            react_1.default.createElement(Navbar_1.Navbar, Object.assign({}, props, { notifications: withNotifications
                    ? {
                        locale: props.locale,
                        isLoading,
                        isOnboarding: notificationsState.isOnboarding,
                        isOpen: notificationsState.isOpen,
                        items: notifications,
                        activeTab: notificationsState.activeTab,
                        onClick: handleNotificationsOpen,
                        onClose: handleNotificationsOpen,
                        onBegin: handleOnBegin,
                        onChangeTab: (_, tab) => setNotificationsState(prevState => (Object.assign(Object.assign({}, prevState), { activeTab: tab })))
                    }
                    : undefined, onClickBalance: handleClickBalance, onClickNavbarItem: handleClickNavbarItem, onClickUserMenuItem: handleClickUserMenuItem, onClickOpen: handleClickOpen, onClickSignIn: handleClickSignIn, onClickSignOut: handleClickSignOut })),
            isUnsupported ? (react_1.default.createElement(UnsupportedNetworkModal_1.default, { chainName: (0, chain_id_1.getChainName)(chainId), expectedChainName: expectedChainName, isSwitchingNetwork: isSwitchingNetwork, onSwitchNetwork: handleSwitchNetwork })) : null)))));
};
exports.default = react_1.default.memo(Navbar);
//# sourceMappingURL=Navbar.js.map